const ConfirmDialog = ({ msgstyle, inProgress, open,
  width,
  title = "Are you sure?",
  message = "Do you want to continue?",
  onConfirm,
  onCancel,
  hideConfirm,
  confirmText = "Yes",
  cancelText = "No", }) => {
  const styles = {
    backdrop: {
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.4)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2000,
    },
    dialog: {
      background: "#fff",
      padding: "20px",
      borderRadius: "8px",
      width: width ? width : "500px",
      boxShadow: "0px 4px 20px rgba(0,0,0,0.2)",
    },
    actions: {
      marginTop: "20px",
      textAlign: "right",
    },
  };
  if (!open) return null;

  return (
    <div style={styles.backdrop}>
      <div style={styles.dialog}>
        <h3 className="font-bold mb-4 text-xl">{title}</h3>
        {(typeof message === 'string') && (
          <div style={msgstyle} dangerouslySetInnerHTML={{ __html: message }}></div>
        )}
        {(typeof message !== 'string') && (
          <div style={msgstyle}>{message}</div>
        )}
        <div className="flex justify-between mt-4">



          {!(hideConfirm) && (
            <>
              <button className="btn btn-cancel" onClick={onCancel}>{cancelText}</button>

              <button disabled={inProgress} className="btn btn-primary" onClick={onConfirm} style={{ marginLeft: "10px" }}>
                {inProgress ? 'In Progress...' : confirmText}
              </button></>
          )}

          {hideConfirm && (
            <>
              <button disabled={inProgress} className="btn btn-primary" onClick={onCancel} >
                {inProgress ? 'In Progress...' : cancelText}
              </button></>
          )}

        </div>
      </div>
    </div>
  );
}


export default ConfirmDialog;